"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageModel = void 0;
const _ = require("lodash");
class ImageModel {
    constructor(data) {
        this.data = data;
    }
    get id() {
        return this.data.id;
    }
    get titel() {
        return this.data.titel;
    }
    get uitgave() {
        return this.data.uitgave;
    }
    get informatiesoort() {
        return this.data.informatiesoort;
    }
    get vakgebied() {
        return this.data.vakgebied;
    }
    get merk() {
        return this.data.merk;
    }
    get assetFormats() {
        return this.data.assetFormats;
    }
    hasAssetFormat(assetFormat) {
        return _.includes(this.assetFormats, assetFormat);
    }
}
exports.ImageModel = ImageModel;
